import { getCandidateDeclarations } from "./root";
import { createLookupCombiner, createLookupSelectors } from "./lib";
import {
  selectCandidateDeclarationIdByAttachmentIdLookup,
  selectCandidateDeclarationIdByEnvdIdLookup,
  selectConsignmentIdsByNvd,
  selectConsignmentIdsByVendorPropertyIdLookup,
} from "./indexes";

export const getCandidateDeclarationById =
  (id: string) =>
  (state: State): CandidateDeclaration | null =>
    getCandidateDeclarations(state)[id] || null;

export const getCandidateDeclarationIdByEnvdId =
  (eNvdId: string) =>
  (state: State): string | null =>
    selectCandidateDeclarationIdByEnvdIdLookup(state)[eNvdId] || null;

export const getCandidateDeclarationIdByAttachmentId =
  (attachmentId: string) =>
  (state: State): string | null =>
    selectCandidateDeclarationIdByAttachmentIdLookup(state)[attachmentId] ||
    null;

export const [
  selectSuggestedConsignmentIdByCandidateDeclarationIdLookup,
  getSuggestedConsignmentIdByCandidateDeclarationId,
] = createLookupSelectors(
  [
    getCandidateDeclarations,
    selectConsignmentIdsByVendorPropertyIdLookup,
    selectConsignmentIdsByNvd,
  ],
  createLookupCombiner(
    (
      candidateDeclaration: CandidateDeclaration,
      consignmentIdsByVendorPropertyIdLookup,
      consignmentIdsByNvd,
    ) => {
      const candidateConsignmentIds: Record<string, number> = {};
      if (candidateDeclaration.originPropertyId) {
        const vendorPropertyConsignmentIds =
          consignmentIdsByVendorPropertyIdLookup[
            candidateDeclaration.originPropertyId
          ] || [];
        vendorPropertyConsignmentIds.forEach(consignmentId =>
          candidateConsignmentIds[consignmentId]
            ? candidateConsignmentIds[consignmentId]++
            : (candidateConsignmentIds[consignmentId] = 1),
        );
      }
      if (candidateDeclaration.serialNumber) {
        const nvdConsignmentIds =
          consignmentIdsByNvd[candidateDeclaration.serialNumber] || [];
        nvdConsignmentIds.forEach(consignmentId =>
          candidateConsignmentIds[consignmentId]
            ? candidateConsignmentIds[consignmentId]++
            : (candidateConsignmentIds[consignmentId] = 1),
        );
      }
      const scores = Object.entries(candidateConsignmentIds);
      if (scores.length === 0) {
        return null;
      }
      scores.sort(
        ([_ignoredA, aScore], [_ignoredB, bScore]) => bScore - aScore,
      );
      return scores[0][0];
    },
  ),
);
